import { render, staticRenderFns } from "./IconHeartFull.vue?vue&type=template&id=77b2c52f"
import script from "./IconHeartFull.vue?vue&type=script&lang=js"
export * from "./IconHeartFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports